/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_History_Col_QtyInputs */

const vi_product_lot_history_col_qty = /** @type {(inputs: Product_Lot_History_Col_QtyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Số lượng`)
};

/**

* @param {Product_Lot_History_Col_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_history_col_qty = /** @type {((inputs?: Product_Lot_History_Col_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_History_Col_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_history_col_qty(inputs)
});